import "./OrgCampaign.css";
import { Button, Card, Row, Col, ListGroup } from "react-bootstrap";
import React, { useState, useEffect, } from "react";
import { useParams } from "react-router-dom";
import { onError } from "../lib/errorLib";
import { Link } from "react-router-dom";
import { API, Storage } from "aws-amplify";
import { useAppContext } from "../lib/contextLib";
import Footer from "./Footer";


export default function OrgCampaign() {
    const [campaigns, setcampaigns] = useState([]);
    const [org, setorg] = useState([]);
    const { id } = useParams();
    const { setcurrentOrgLogo, setcurrentOrgObj } = useAppContext();

    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        async function onLoad() {



            try {

                var org = await API.get("mygiving", `/organization/${id}`);
                //console.log("disp:"+org);

                setorg(org);




                var campaigns = await API.get("mygiving", `/organization/${id}/campaigns`);
                //Object.entries(campaigns).forEach(async (nft)=>{nft.imageURL=await Storage.vault.get(nft.imageURL)});
                for (var i = 0; i <= campaigns.length - 1; i++) {
                    if (campaigns[i].imageURL) {
                        campaigns[i].imageURL = await Storage.get(campaigns[i].imageURL, { level: 'public' });
                    }

                }
                //campaigns[4].imageURL = await Storage.vault.get(campaigns[4].imageURL);
                setcampaigns(campaigns);
                //console.log("About to setup org"+org.orgBannerLogo);
                setcurrentOrgLogo(org.orgBannerLogo);
                //setcurrentOrgObj(org);

            } catch (e) {
                onError(e);
            }

            setIsLoading(false);

        }
        onLoad();

    }, [id, setcurrentOrgLogo]);

    /*
    function loadcampaigns() {
        return API.get("mygiving", `/organization/${id}/campaigns`);
    }
*/
    setcurrentOrgLogo(org.orgBannerLogo);
    setcurrentOrgObj(org);
    //console.log("currentOrg - After:" + currentOrg + "id:", id);
    function rendercampgainsList(campaigns) {
        return (
            <>
                <Row xs={1}   className="g-4 justify-content-md-center">
                    {campaigns.map(({ sk, campaignName, urlPath, imagePublicURL, name, qty, tokenAddress, tokenChain, createdAt }) => (
                        <Col key={sk}>
                            <Card className="OrgListItem-main-card text-center"   >
                                <div className="imageHolder mx-auto">
                                    <Card.Img className="OrgListItem-img mx-auto" src={imagePublicURL} />
                                </div>
                                <Card.Body>
                                    <Card.Title className=" fw-bold text-bold text-center">{campaignName}</Card.Title>                                  
                                </Card.Body>
                                <Card.Footer className="mx-auto">
                                    <Link to={`/org/${id}/${urlPath}`}>
                                        <Button style={{ 'backgroundColor': org.orgColorTheme }}>
                                            Details
                                        </Button>
                                    </Link>
                                </Card.Footer>

                            </Card>
                        </Col>

                    ))}

                </Row>

            </>
        );
    }



    function rendercampaigns() {
        return (
            <div className="nfts">
                <h2 className="mt-4">{id} Campaigns</h2>
                {!isLoading ?

                    <div className="mt-1 border-bottom mb-3 mx-auto">
                        <p>{org.orgMissionStatement}</p>

                        <ListGroup className="mb-3" horizontal="sm">
                            <ListGroup.Item>
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold text-bold text-sm">Website</div>
                                    <a target="_blank" rel="noreferrer" href={org.orgWebsite} class="link-primary">{org.orgWebsite}</a>
                                </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold text-bold text-sm">Tax ID</div>
                                    {org.orgTaxID}
                                </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold text-bold text-sm">Org Type</div>
                                    {org.orgType}
                                </div>
                                </ListGroup.Item>
                            <ListGroup.Item>
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold text-bold text-sm">Location</div>
                                    {org.orgLocation}
                                </div>
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                    : null}
                {!isLoading && rendercampgainsList(campaigns) }
               
            </div>
        );
    }

    return (
        <div className="Home  container" >
            <div className="mt-1 bannerImg  container" style={{
                backgroundImage: `url(${org.orgBannerImage})`,
            }}>

                <div className="text-block">
                    <h4>{org.orgWelcomeMessageHeader}</h4>
                    <p>{org.orgWelcomeMessage}</p>
                </div>


            </div>
            {rendercampaigns()}
            {!isLoading ? <Footer />:null}
           
         </div>
    );
}